import {Component, EventEmitter, Input, Output} from "@angular/core";
import {FormsModule} from "@angular/forms";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'search-input',
  imports: [FormsModule, FaIconComponent],
  templateUrl: './search-input.html'
})
export class SearchInputComponent {
  @Input('searchText') searchText: string = ''
  @Input('placeholder') placeholder: string = 'Search...'
  @Input('containerClass') containerClass: string = 'lg:w-80'
  @Output() searchTextChange = new EventEmitter<string>()

  protected readonly faMagnifyingGlass = faMagnifyingGlass

  onChange(value: string) {
    this.searchText = value
    this.searchTextChange.emit(value)
  }
}
